import { NFTsProvider } from '../providers/NFTsContractProvider';
import NFTContractPage from './nft-contracts.page';

const NFTContractRoutes = () => {
	return <NFTContractPage />;
};

export default NFTContractRoutes;
